import axios from 'axios';
import * as endPoints from '../../../../Constants/Endpoints'

export function AddService(name, serviceDuration, servicePrice, description, acceptOnlinePayment, priceToPay, serviceImage) {
    const duration = Number(serviceDuration)
    const price = Number(servicePrice)

    const formData = new FormData();
    formData.append("name", name)
    formData.append("duration", duration)
    formData.append("description", description)
    formData.append("price", price)
    formData.append("acceptOnlinePayment", acceptOnlinePayment)
    formData.append("priceToPay", priceToPay)
    formData.append("serviceImage", serviceImage)

    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Service, formData,
    {
        headers: {
            "Content-Type" : ["multipart/form-data"],
        },
        withCredentials: true
    });
}

export function EditService(serviceId, name, serviceDuration, servicePrice, description, status, acceptOnlinePayment, priceToPay, serviceImage) {
    const duration = Number(serviceDuration)
    const price = Number(servicePrice)
    const formData = new FormData();
    formData.append("serviceId", serviceId)
    formData.append("name", name)
    formData.append("duration", duration)
    formData.append("description", description)
    formData.append("price", price)
    formData.append("status", status)
    formData.append("acceptOnlinePayment", acceptOnlinePayment)
    formData.append("priceToPay", priceToPay)
    formData.append("serviceImage", serviceImage)
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Service, formData,
    {
        headers: {
            "Content-Type" : ["multipart/form-data"],
        },
        withCredentials: true
    });
}


export function GetServices() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Services,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function ActivateService(serviceId, name, description, serviceDuration, servicePrice) {
    const duration = Number(serviceDuration)
    const price = Number(servicePrice)
    const serviceDetails = {
        serviceId,
        name,
        duration,
        description,
        price
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ActivateService, serviceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DisableService(serviceId, name, description, serviceDuration, servicePrice) {
    const duration = Number(serviceDuration)
    const price = Number(servicePrice)
    const serviceDetails = {
        serviceId,
        name,
        duration,
        description,
        price
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisableService, serviceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DeleteService(serviceId, name, description, serviceDuration, servicePrice) {
    const duration = Number(serviceDuration)
    const price = Number(servicePrice)
    const serviceDetails = {
        serviceId,
        name,
        duration,
        description,
        price
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DeleteService, serviceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function GetServiceDurations() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServiceDurations,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function AddBarber(
    name,
    serviceIds,
    imageFile,
    sundayStartHours,
    sundayEndHours,
    mondayStartHours, 
    mondayEndHours,
    tuesdayStartHours,
    tuesdayEndHours,
    wednesdayStartHours,
    wednesdayEndHours,
    thursdayStartHours,
    thursdayEndHours,
    fridayStartHours,
    fridayEndHours,
    saturdayStartHours,
    saturdayEndHours,
    barberColour
) {

    const formData = new FormData();
    formData.append("name", name)
    formData.append("serviceIds", serviceIds)
    formData.append("imageFile", imageFile)
    formData.append("sundayStartHours", sundayStartHours)
    formData.append("sundayEndHours", sundayEndHours)
    formData.append("MondayStartHours", mondayStartHours)
    formData.append("mondayEndHours", mondayEndHours)
    formData.append("tuesdayStartHours", tuesdayStartHours)
    formData.append("tuesdayEndHours", tuesdayEndHours)
    formData.append("wednesdayStartHours", wednesdayStartHours)
    formData.append("wednesdayEndHours", wednesdayEndHours)
    formData.append("thursdayStartHours", thursdayStartHours)
    formData.append("thursdayEndHours", thursdayEndHours)
    formData.append("fridayStartHours", fridayStartHours)
    formData.append("fridayEndHours", fridayEndHours)
    formData.append("saturdayStartHours", saturdayStartHours)
    formData.append("saturdayEndHours", saturdayEndHours)
    formData.append("barberColour", barberColour)

    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barber, formData,
    {
        headers: {
            "Content-Type" : ["multipart/form-data"],
        },

        withCredentials: true
    });
}

export function EditBarber(
    barberId,
    name,
    serviceIds,
    imageFile,
    sundayStartHours,
    sundayEndHours,
    mondayStartHours, 
    mondayEndHours,
    tuesdayStartHours,
    tuesdayEndHours,
    wednesdayStartHours,
    wednesdayEndHours,
    thursdayStartHours,
    thursdayEndHours,
    fridayStartHours,
    fridayEndHours,
    saturdayStartHours,
    saturdayEndHours,
    barberColour) {

        const formData = new FormData();
        formData.append("barberId", barberId)
        formData.append("name", name)
        formData.append("serviceIds", serviceIds)
        formData.append("imageFile", imageFile)
        formData.append("sundayStartHours", sundayStartHours)
        formData.append("sundayEndHours", sundayEndHours)
        formData.append("MondayStartHours", mondayStartHours)
        formData.append("mondayEndHours", mondayEndHours)
        formData.append("tuesdayStartHours", tuesdayStartHours)
        formData.append("tuesdayEndHours", tuesdayEndHours)
        formData.append("wednesdayStartHours", wednesdayStartHours)
        formData.append("wednesdayEndHours", wednesdayEndHours)
        formData.append("thursdayStartHours", thursdayStartHours)
        formData.append("thursdayEndHours", thursdayEndHours)
        formData.append("fridayStartHours", fridayStartHours)
        formData.append("fridayEndHours", fridayEndHours)
        formData.append("saturdayStartHours", saturdayStartHours)
        formData.append("saturdayEndHours", saturdayEndHours)
        formData.append("barberColour", barberColour)

        return axios.put(
            process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barber, formData,
        {
            headers: {
                "Content-Type" : ["multipart/form-data"],
            },
    
            withCredentials: true
        });
    }

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetFutureAppointmentsByBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.FutureAppointments,
    {
        params: {barberId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetBarberWorkingTimes() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.BarberWorkingTimes,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DeleteBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DeleteBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function DisableBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisableBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function ActivateBarber(barberId) {
    const barberToDelete = {
        barberId
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ActivateBarber, barberToDelete,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function getCroppedImg(imageSrc, croppedAreaPixels) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );
      canvas.toBlob((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result)

        // const url = URL.createObjectURL(blob);
        // resolve(url); // You can return the blob too for backend
      }, 'image/jpeg');
    };
  });
}